import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { AiOutlineFilePdf } from "react-icons/ai"; // <-- ícono de PDF

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>

        {/* GitHub o Blog */}
        {props.ghLink && (
          <Button variant="primary" href={props.ghLink} target="_blank">
            <BsGithub /> &nbsp;
            {props.isBlog ? "Blog" : "GitHub"}
          </Button>
        )}

        {/* Demo / StoryMap */}
        {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <CgWebsite /> &nbsp;
            {"Link"}
          </Button>
        )}

        {/* Noticias */}
        {props.newsLinks &&
          props.newsLinks.map((news, index) => (
            <Button
              key={index}
              variant="secondary"
              href={news.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginLeft: "10px", verticalAlign: "middle" }}
            >
              📰 {news.text}
            </Button>
          ))}

        {/* PDF (nuevo botón) */}
        {props.pdfLink && (
          <Button
            variant="secondary"
            href={props.pdfLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginLeft: "10px" }}
          >
            <AiOutlineFilePdf /> &nbsp;
            Download PDF
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;

